import { render, staticRenderFns } from "./Ingredients.vue?vue&type=template&id=b9566dfc&scoped=true&"
import script from "./Ingredients.vue?vue&type=script&lang=js&"
export * from "./Ingredients.vue?vue&type=script&lang=js&"
import style0 from "./Ingredients.vue?vue&type=style&index=0&id=b9566dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9566dfc",
  null
  
)

export default component.exports